import React, { useState, useContext, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRobot, faSun, faMoon } from "@fortawesome/free-solid-svg-icons";
import "../../styles/logistic/LogisticNav.css";
import { ThemeContext } from "../../contexts/ThemeContext";
import { useTranslation } from "react-i18next";
import CustomDropdown from "../app/CustomDropdown";
import changeLanguage from "../../services/ChangeLanguage";

const LogisticNav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const themeContext = useContext(ThemeContext);

  if (!themeContext) {
    throw new Error("ThemeContext must be used within a ThemeProvider");
  }

  const { isLightMode, toggleTheme } = themeContext;

  useEffect(() => {
    document.body.setAttribute("data-theme", isLightMode ? "light" : "dark");
  }, [isLightMode]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const languageOptions = [
    { value: "en", label: "English" },
    { value: "es", label: "Español" },
  ];

  return (
    <nav className="logistic-navbar">
      <div className="logistic-container logistic-nav-content">
        <div className="logistic-logo">
          <FontAwesomeIcon icon={faRobot} />
          <div>
            LogisticBot<span className="logistic-ai-badge">IA</span>
          </div>
        </div>
        <ul className={`logistic-nav-links ${isMenuOpen ? "active" : ""}`}>
          <li>
            <a href="#beneficios">{t("LogisticNav:benefits")}</a>
          </li>
          <li>
            <a href="#como-funciona">{t("LogisticNav:howItWorks")}</a>
          </li>
          <li>
            <a href="#casos">{t("LogisticNav:useCases")}</a>
          </li>
          <li>
            <a href="#testimonios">{t("LogisticNav:testimonials")}</a>
          </li>
          <li>
            <a href="#cta" className="logistic-btn-nav" data-i18n="nav_cta">
              {t("LogisticNav:requestDemo")}
            </a>
          </li>
          <li>
            <div className="logistic-lang-selector-mobile">
              <CustomDropdown
                options={languageOptions}
                defaultValue={i18n.language || "es"}
                onChange={changeLanguage}
              />
            </div>
          </li>
          {/* BOTONO MODO CLARO OCULTO TEMPORALMENTE
          <li>
            <div className="theme-switch-wrapper">
              <label
                className="theme-switch"
                htmlFor="logistic-checkbox-mobile"
              >
                <input
                  type="checkbox"
                  id="logistic-checkbox-mobile"
                  checked={isLightMode}
                  onChange={toggleTheme}
                />
                <div className="theme-slider round">
                  <FontAwesomeIcon
                    icon={isLightMode ? faSun : faMoon}
                    className="theme-icon"
                  />
                </div>
              </label>
            </div>
          </li>
          */}
          <li>
            <div className="logistic-lang-selector-desktop">
              <CustomDropdown
                options={languageOptions}
                defaultValue={i18n.language || "es"}
                onChange={changeLanguage}
              />
            </div>
          </li>
        </ul>

        <div
          className={`logistic-hamburger ${isMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
        >
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </div>
    </nav>
  );
};

export default LogisticNav;
